var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.close,
        title: _vm.title,
        printStyle: _vm.printStyle,
        htmlForPrint: _vm.htmlForPrint,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-bar-chart" }),
          _vm._v(" Бизнес-коэффициенты"),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "htmlContent",
          staticClass: "modal__body",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _vm.years.length && _vm.targetObj
            ? _c("business-index-table", {
                ref: "table",
                attrs: {
                  years: _vm.years,
                  targetObj: _vm.targetObj,
                  inModal: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }